export const GET_NOTIFICATION_COUNTER = 'GET_NOTIFICATION_COUNTER';
export const RECEIVE_NOTIFICATION_COUNTER = 'RECEIVE_NOTIFICATION_COUNTER';
